// extracted by mini-css-extract-plugin
export var dividerLine = "_9s-3";
export var itemImage = "_9s-9";
export var lightDivider = "_9s-4";
export var modalContent = "_9s-5";
export var modalContentCompact = "_9s-6";
export var productCard = "_9s-a";
export var productImage = "_9s-b";
export var productImageCompact = "_9s-7";
export var productImagePlaceholder = "_9s-c";
export var productImagePlaceholderCompact = "_9s-8";
export var progressBarBackground = "_9s-1";
export var progressBarContainer = "_9s-0";
export var progressBarFill = "_9s-2";